const US_COUNTRIES = new Set([
  'united states',
  'usa',
  'us',
  'canada',
]);

const EUROPE_COUNTRIES = new Set([
  'france',
  'italy',
  'united kingdom',
  'uk',
  'germany',
  'spain',
  'switzerland',
  'netherlands',
  'belgium',
  'sweden',
  'denmark',
  'norway',
  'finland',
  'austria',
  'portugal',
  'ireland',
  'europe',
]);

const CERTAIN = new Set(['won', 'approved']);

const normalizeCountry = (value) =>
  String(value || '')
    .trim()
    .toLowerCase();

export const LENDERS = {
  mpower: {
    id: 'mpower',
    name: 'MPOWER Financing',
    regions: ['us'],
    kind: 'loan',
    url: 'https://www.mpowerfinancing.com/',
    amount_note: 'No cosigner, up to about $100k, US/Canada schools.',
    best_months: [1, 2, 3, 4, 5],
    late_months: [6, 7, 8],
    window_label: 'Jan–May for a Fall start',
    late_label: 'Visa queue builds in summer',
    note: 'Rolling credit file, not a pot that empties. Apply 3–6 months before start so the visa letter is ready.',
  },
  prodigy: {
    id: 'prodigy',
    name: 'Prodigy Finance',
    regions: ['us', 'europe'],
    kind: 'loan',
    url: 'https://www.prodigyfinance.com/',
    amount_note: 'Matching rounds; can cover up to 100% of cost of attendance.',
    best_months: [1, 2, 3, 4, 5, 6],
    late_months: [7, 8, 9],
    window_label: 'Jan–Jun after an offer',
    late_label: 'Investor capital can freeze schools mid-cycle',
    note: 'Start the file as soon as you have an offer. Capital partners have paused schools mid-cycle (seen for Fall 2026). Typical windows, not live availability.',
  },
  juno: {
    id: 'juno',
    name: 'Juno',
    regions: ['us'],
    kind: 'loan',
    url: 'https://joinjuno.com/group/mba',
    amount_note: 'Marketplace, not a lender. MBA group rates.',
    best_months: [6],
    late_months: [7, 8],
    window_label: 'Rates often drop in June for the next Fall',
    late_label: 'Join now, apply when rates publish',
    note: 'Join the MBA group now. Apply to the underlying lender only when negotiated rates are out.',
  },
  ascent: {
    id: 'ascent',
    name: 'Ascent',
    regions: ['us'],
    kind: 'loan',
    url: 'https://www.ascentfunding.com/',
    amount_note: 'Mostly US citizens or a US cosigner.',
    best_months: [5, 6, 7],
    late_months: [8],
    window_label: '60–90 days before term (May–Jul for Fall)',
    late_label: 'Late for Fall disbursement after August',
    note: 'Rolling. Confirm international eligibility before you count on it.',
  },
  sallie_mae: {
    id: 'sallie_mae',
    name: 'Sallie Mae',
    regions: ['us'],
    kind: 'loan',
    url: 'https://www.salliemae.com/',
    amount_note: 'US citizen / PR, or a US cosigner.',
    best_months: [5, 6, 7],
    late_months: [8],
    window_label: '60–90 days before term',
    late_label: 'Late for Fall after August',
    note: 'Rolling private loan. International students almost always need a US cosigner.',
  },
  college_ave: {
    id: 'college_ave',
    name: 'College Ave',
    regions: ['us'],
    kind: 'loan',
    url: 'https://www.collegeave.com/',
    amount_note: 'US citizen / PR, or a US cosigner.',
    best_months: [5, 6, 7],
    late_months: [8],
    window_label: '60–90 days before term',
    late_label: 'Late for Fall after August',
    note: 'Rolling. Use only if you have a US cosigner path.',
  },
  earnest: {
    id: 'earnest',
    name: 'Earnest',
    regions: ['us'],
    kind: 'loan',
    url: 'https://www.earnest.com/',
    amount_note: 'US citizen / PR in most cases.',
    best_months: [5, 6, 7],
    late_months: [8],
    window_label: '60–90 days before term',
    late_label: 'Late for Fall after August',
    note: 'Rolling. Check citizenship rules before adding it to the mix.',
  },
  sofi: {
    id: 'sofi',
    name: 'SoFi',
    regions: ['us'],
    kind: 'loan',
    url: 'https://www.sofi.com/student-loans/',
    amount_note: 'US citizen / PR in most cases.',
    best_months: [5, 6, 7],
    late_months: [8],
    window_label: '60–90 days before term',
    late_label: 'Late for Fall after August',
    note: 'Rolling. Not a no-cosigner international option.',
  },
  leap: {
    id: 'leap',
    name: 'Leap Finance',
    regions: ['us', 'europe'],
    kind: 'loan',
    url: 'https://leapfinance.com/',
    amount_note: 'India-origin students, US and Europe programs.',
    best_months: [1, 2, 3, 4],
    late_months: [5, 6],
    window_label: 'Jan–Apr right after the admit',
    late_label: 'Slower after May',
    note: 'Apply after the offer, 3–4 months before start.',
  },
  avanse: {
    id: 'avanse',
    name: 'Avanse',
    regions: ['us', 'europe'],
    kind: 'loan',
    url: 'https://www.avanse.com/',
    amount_note: 'India NBFC, often collateral or co-borrower.',
    best_months: [1, 2, 3, 4],
    late_months: [5, 6],
    window_label: 'Jan–Apr after the admit',
    late_label: 'Public-bank collateral files drag after May',
    note: 'Sanction can be days; collateral verification is the slow part.',
  },
  credila: {
    id: 'credila',
    name: 'HDFC Credila',
    regions: ['us', 'europe'],
    kind: 'loan',
    url: 'https://www.hdfccredila.com/',
    amount_note: 'India education loan, collateral common at MBA amounts.',
    best_months: [1, 2, 3, 4],
    late_months: [5, 6],
    window_label: 'Jan–Apr after the admit',
    late_label: 'Slower after May',
    note: 'Start the file as soon as the offer letter is out.',
  },
  incred: {
    id: 'incred',
    name: 'InCred',
    regions: ['us', 'europe'],
    kind: 'loan',
    url: 'https://www.incred.com/',
    amount_note: 'India NBFC, collateral-free up to a cap.',
    best_months: [1, 2, 3, 4],
    late_months: [5, 6],
    window_label: 'Jan–Apr after the admit',
    late_label: 'Slower after May',
    note: 'Typical windows, not live availability.',
  },
  auxilo: {
    id: 'auxilo',
    name: 'Auxilo',
    regions: ['us', 'europe'],
    kind: 'loan',
    url: 'https://www.auxilo.com/',
    amount_note: 'India NBFC education loan.',
    best_months: [1, 2, 3, 4],
    late_months: [5, 6],
    window_label: 'Jan–Apr after the admit',
    late_label: 'Slower after May',
    note: 'Typical windows, not live availability.',
  },
  nomad: {
    id: 'nomad',
    name: 'Nomad Credit',
    regions: ['us', 'europe'],
    kind: 'research',
    url: 'https://www.nomadcredit.com/',
    amount_note: 'Aggregator, not a lender.',
    best_months: [1, 2, 3, 4],
    late_months: [5, 6],
    window_label: 'Use it to compare, then add the real lender here',
    late_label: '',
    note: 'Research only. Add the lender you actually apply to as a source.',
  },
  lendwise: {
    id: 'lendwise',
    name: 'Lendwise',
    regions: ['europe'],
    kind: 'loan',
    url: 'https://lendwise.com/borrow/student-loans/',
    amount_note: 'UK + selected EU schools (INSEAD, HEC, Bocconi, LBS, IESE).',
    best_months: [1, 2, 3, 4, 5, 6],
    late_months: [7, 8],
    window_label: 'After the offer, 8–12 weeks before deposit or visa',
    late_label: 'No public pot-empty date — still apply early',
    note: 'Rolling after an offer. Provisional quote in about two business days.',
  },
  future_finance: {
    id: 'future_finance',
    name: 'Future Finance',
    regions: ['europe'],
    kind: 'loan',
    url: 'https://www.futurefinance.com/',
    amount_note: 'UK postgraduate loans, rolling.',
    best_months: [3, 4, 5, 6],
    late_months: [7, 8],
    window_label: 'Spring–early summer for a Sept start',
    late_label: 'Tighter after July',
    note: 'Rolling. Check course and residency rules.',
  },
  sfe: {
    id: 'sfe',
    name: 'Student Finance England',
    regions: ['europe'],
    kind: 'loan',
    url: 'https://www.gov.uk/masters-loan',
    amount_note: 'UK residents only. Master’s loan, not a full MBA stack.',
    best_months: [3, 4, 5],
    late_months: [6, 7, 8],
    window_label: 'Usually opens in March for a Sept start',
    late_label: 'You can apply later, but do not wait',
    note: 'Most international students are not eligible. Typical windows, not live availability.',
  },
  bpifrance: {
    id: 'bpifrance',
    name: 'Prêt étudiant garanti (Bpifrance)',
    regions: ['europe'],
    kind: 'loan',
    url: 'https://www.etudiant.gouv.fr/',
    amount_note: 'French / EU (often 2 years of residence). Partner banks: SG, BNP, Caisse d’Épargne.',
    best_months: [9, 10, 11, 12],
    late_months: [1, 2, 3],
    window_label: 'Bank envelopes Sept–Dec',
    late_label: 'Often gone Jan–Mar',
    note: 'Most non-EU internationals are not eligible. Ask the branch — there is no central pot.',
  },
  smarto: {
    id: 'smarto',
    name: 'Smarto + French bank',
    regions: ['europe'],
    kind: 'loan',
    url: 'https://www.smarto.fr/',
    amount_note: 'Digital guarantor for CGE schools, then a French bank loan.',
    best_months: [3, 4, 5],
    late_months: [6, 7],
    window_label: 'Bank appointment before June for a Sept start',
    late_label: 'Summer appointments slip past deposit dates',
    note: 'The guarantee is rolling; the bank slot is the bottleneck.',
  },
  employer: {
    id: 'employer',
    name: 'Current employer',
    regions: ['europe', 'us'],
    kind: 'employer',
    url: '',
    amount_note: 'Negotiate sponsorship, a loan, or a bond — not a seasonal fund.',
    best_months: [10, 11, 12, 1],
    late_months: [],
    window_label: 'Start 6–9 months before you resign (Q4/Q1 budgets)',
    late_label: '',
    note: 'Write the pitch, then add the agreed amount as an employer source.',
  },
};

export const PLAYBOOKS = {
  us: {
    id: 'us',
    label: 'US / Canada',
    currency: 'USD',
    recipeTotal: 250000,
    headline: 'Typical US MBA stack: $50k cash + $100k scholarship + $50k loan + $50k internship',
    applyWindow:
      'Apply for school aid in Round 1 or Round 2. Open lender files as soon as you have an offer (Jan–May for Fall).',
    slices: [
      {
        id: 'cash',
        kinds: ['savings', 'family'],
        target: 50000,
        label: 'You or family save $50k',
        note: 'Deposit and I-20. This cash has to exist before you arrive.',
        when: 'before_arrival',
        defaultName: 'Personal and family savings',
      },
      {
        id: 'scholarship',
        kinds: ['scholarship'],
        target: 100000,
        label: 'Aim for a $100k scholarship',
        note: 'School merit or need-based. Odds drop hard after Round 2.',
        when: 'r1_r2',
        defaultName: 'School merit / need-based aid',
      },
      {
        id: 'loan',
        kinds: ['loan'],
        target: 50000,
        label: 'Take a $50k loan',
        note: 'MPOWER, Prodigy, Juno, or a home-country NBFC.',
        when: 'after_offer',
        defaultName: 'Graduate loan',
      },
      {
        id: 'internship',
        kinds: ['internship'],
        target: 50000,
        label: 'Internship during the program ($50k)',
        note: 'Does not fund the visa or the deposit. Count it only after an offer is signed.',
        when: 'during_program',
        defaultName: 'In-program internship',
      },
    ],
  },
  europe: {
    id: 'europe',
    label: 'Europe',
    currency: 'EUR',
    recipeTotal: null,
    headline: 'Europe: apply Round 1–2, win €30k aid, save €50–60k, loan or employer for the rest',
    applyWindow:
      'Apply in Round 1 or Round 2. Round 3 scholarships are often already gone.',
    slices: [
      {
        id: 'scholarship',
        kinds: ['scholarship'],
        target: 30000,
        label: 'Win a €30k scholarship',
        note: 'School aid is decided with the admit. Do not wait for Round 3.',
        when: 'r1_r2',
        defaultName: 'School scholarship',
      },
      {
        id: 'cash',
        kinds: ['savings', 'family'],
        target: 55000,
        targetLow: 50000,
        targetHigh: 60000,
        label: 'Save €50–60k',
        note: 'Your cash plus family. Needed for the deposit and the first months.',
        when: 'before_arrival',
        defaultName: 'Personal and family savings',
      },
      {
        id: 'loan',
        kinds: ['loan', 'employer'],
        target: 'remainder',
        label: 'Cover the rest with a loan or your employer',
        note: 'Negotiate with your current firm, or apply to Prodigy, Lendwise, or a home-country lender.',
        when: 'after_offer',
        defaultName: 'Graduate loan or employer sponsorship',
      },
    ],
  },
};

export function playbookIdForCountry(country, currency) {
  const key = normalizeCountry(country);
  if (US_COUNTRIES.has(key)) {
    return 'us';
  }
  if (EUROPE_COUNTRIES.has(key)) {
    return 'europe';
  }
  if (String(currency || '').toUpperCase() === 'USD') {
    return 'us';
  }
  return 'europe';
}

export function getPlaybook(country, currency) {
  return PLAYBOOKS[playbookIdForCountry(country, currency)];
}

export function lendersForPlaybook(playbookId) {
  return Object.values(LENDERS).filter((lender) =>
    lender.regions.includes(playbookId)
  );
}

const INDIA = new Set(['india', 'indian']);
const UNITED_STATES = new Set(['united states', 'usa', 'us', 'american']);
const UNITED_KINGDOM = new Set([
  'united kingdom',
  'uk',
  'britain',
  'british',
  'england',
  'scotland',
  'wales',
]);
const FRANCE = new Set(['france', 'french']);
const EUROPEAN_UNION = new Set(
  [
    ...EUROPE_COUNTRIES,
    'french',
    'german',
    'italian',
    'spanish',
    'dutch',
    'belgian',
    'portuguese',
    'irish',
    'swedish',
    'danish',
    'finnish',
    'austrian',
    'polish',
    'greek',
  ].filter((name) => !['united kingdom', 'uk', 'europe'].includes(name))
);

export const IDENTITY_COUNTRIES = [
  'Cameroon',
  'Nigeria',
  'Ghana',
  'Kenya',
  'Ivory Coast',
  'Senegal',
  'Morocco',
  'Tunisia',
  'Algeria',
  'South Africa',
  'Egypt',
  'Rwanda',
  'Uganda',
  'India',
  'China',
  'Lebanon',
  'Brazil',
  'Mexico',
  'France',
  'United Kingdom',
  'Germany',
  'Italy',
  'Spain',
  'Netherlands',
  'Belgium',
  'Switzerland',
  'United States',
  'Canada',
];

const LENDER_META = {
  mpower: {
    audiences: ['international', 'india'],
    who: 'International students at US or Canadian schools. No US cosigner needed.',
    applyWhen: 'January to May if you start in the Fall',
    avoidWhen: 'June to August — visa letters get slower, not because a pot empties',
    now: {
      best: 'This is the right time. Apply now so the visa letter is ready before summer.',
      late: 'You can still apply. Expect a longer wait for the visa letter.',
      open: 'Not the peak month. Open a file if you already have an offer; the busy window is January–May.',
    },
  },
  prodigy: {
    audiences: ['international', 'india', 'uk', 'france', 'eu'],
    who: 'International students at supported schools. No cosigner. Capital is matched in rounds.',
    applyWhen: 'January to June, as soon as you have an offer',
    avoidWhen: 'July to September — investor capital can freeze schools mid-cycle',
    now: {
      best: 'Start the file now. Matching rounds fill as investors allocate capital.',
      late: 'Late for this intake. You can still try; some schools get paused when capital runs out.',
      open: 'You can register now. Complete the file as soon as the offer arrives.',
    },
  },
  juno: {
    audiences: ['us', 'international'],
    who: 'A rate marketplace, not a lender. Useful if you will apply to a US private loan.',
    applyWhen: 'Join now. MBA group rates usually publish in June for the next Fall',
    avoidWhen: 'Do not wait for June to join — only the rate application waits',
    now: {
      best: 'Rates are typically out. Compare, then add the real lender as a source.',
      late: 'Rates may already be out. Join and apply to the underlying lender.',
      open: 'Join the MBA group now. Apply to a lender only when rates drop (usually June).',
    },
  },
  ascent: {
    audiences: ['us'],
    who: 'Mostly US citizens or a US cosigner.',
    applyWhen: '60–90 days before term (May–July for Fall)',
    avoidWhen: 'After August for a Fall start — disbursement gets tight',
    now: {
      best: 'This is the usual application window for a Fall start.',
      late: 'Late for Fall disbursement. Confirm the school can still accept the loan.',
      open: 'Too early or off-cycle. Come back 60–90 days before classes.',
    },
  },
  sallie_mae: {
    audiences: ['us'],
    who: 'US citizen or permanent resident, or a US cosigner.',
    applyWhen: '60–90 days before term',
    avoidWhen: 'After August for a Fall start',
    now: {
      best: 'This is the usual window for Fall disbursement.',
      late: 'Late for Fall. Ask the school financial-aid office first.',
      open: 'Wait until 60–90 days before the term unless you already have an offer.',
    },
  },
  college_ave: {
    audiences: ['us'],
    who: 'US citizen or permanent resident, or a US cosigner.',
    applyWhen: '60–90 days before term',
    avoidWhen: 'After August for a Fall start',
    now: {
      best: 'This is the usual window for Fall disbursement.',
      late: 'Late for Fall. Confirm disbursement dates with the school.',
      open: 'Wait until 60–90 days before the term.',
    },
  },
  earnest: {
    audiences: ['us'],
    who: 'US citizen or permanent resident in most cases.',
    applyWhen: '60–90 days before term',
    avoidWhen: 'After August for a Fall start',
    now: {
      best: 'This is the usual window for Fall disbursement.',
      late: 'Late for Fall disbursement.',
      open: 'Wait until 60–90 days before the term.',
    },
  },
  sofi: {
    audiences: ['us'],
    who: 'US citizen or permanent resident in most cases.',
    applyWhen: '60–90 days before term',
    avoidWhen: 'After August for a Fall start',
    now: {
      best: 'This is the usual window for Fall disbursement.',
      late: 'Late for Fall disbursement.',
      open: 'Wait until 60–90 days before the term.',
    },
  },
  leap: {
    audiences: ['india'],
    who: 'Students from India. Covers many US and Europe programs.',
    applyWhen: 'January to April, right after the admit',
    avoidWhen: 'After May — files move more slowly',
    now: {
      best: 'Apply now, 3–4 months before you start.',
      late: 'Still possible, but processing after May is slower.',
      open: 'Wait for the offer, then file in January–April.',
    },
  },
  avanse: {
    audiences: ['india'],
    who: 'India NBFC. Often needs collateral or a co-borrower.',
    applyWhen: 'January to April after the admit',
    avoidWhen: 'After May — collateral checks drag',
    now: {
      best: 'Start the file now. Sanction can be days; collateral is the slow part.',
      late: 'You can still apply. Collateral verification takes longer after May.',
      open: 'Wait for the offer letter, then file in January–April.',
    },
  },
  credila: {
    audiences: ['india'],
    who: 'India education loan. Collateral is common at MBA amounts.',
    applyWhen: 'January to April after the admit',
    avoidWhen: 'After May — slower sanctions',
    now: {
      best: 'Start as soon as the offer letter is out.',
      late: 'Still possible; expect a slower sanction.',
      open: 'Wait for the offer, then file in January–April.',
    },
  },
  incred: {
    audiences: ['india'],
    who: 'India NBFC. Collateral-free up to a cap.',
    applyWhen: 'January to April after the admit',
    avoidWhen: 'After May — slower files',
    now: {
      best: 'This is the usual window after an admit.',
      late: 'Still possible; files move more slowly after May.',
      open: 'Wait for the offer, then file in January–April.',
    },
  },
  auxilo: {
    audiences: ['india'],
    who: 'India NBFC education loan.',
    applyWhen: 'January to April after the admit',
    avoidWhen: 'After May — slower files',
    now: {
      best: 'This is the usual window after an admit.',
      late: 'Still possible; files move more slowly after May.',
      open: 'Wait for the offer, then file in January–April.',
    },
  },
  nomad: {
    audiences: ['india'],
    who: 'A comparison site, not a lender. Use it to pick the Indian or international lender.',
    applyWhen: 'Anytime you are comparing — then add the real lender here',
    avoidWhen: '',
    now: {
      best: 'Compare now, then add the lender you will actually apply to.',
      late: 'Compare now, then add the lender you will actually apply to.',
      open: 'Compare now, then add the lender you will actually apply to.',
    },
  },
  lendwise: {
    audiences: ['international', 'uk', 'eu', 'france', 'india'],
    who: 'UK and selected EU schools (INSEAD, HEC, Bocconi, LBS, IESE). Rolling after an offer.',
    applyWhen: 'After the offer, 8–12 weeks before the deposit or visa',
    avoidWhen: 'Last month before the deposit — no public “sold out” date, but files stall',
    now: {
      best: 'Good time if you already have an offer. Provisional quote in about two days.',
      late: 'Still rolling. Apply now if a deposit or visa is close.',
      open: 'You can apply after the offer. Aim for 8–12 weeks before you must pay.',
    },
  },
  future_finance: {
    audiences: ['uk'],
    who: 'UK postgraduate loans. Check residency and course rules.',
    applyWhen: 'March to June for a September start',
    avoidWhen: 'After July — tighter for September',
    now: {
      best: 'This is the usual window for a September start.',
      late: 'Tighter for September. Confirm the course is still eligible.',
      open: 'Applications are rolling. The busy window is spring.',
    },
  },
  sfe: {
    audiences: ['uk'],
    who: 'UK residents only. A Master’s loan — not a full MBA stack.',
    applyWhen: 'Usually opens in March for a September start',
    avoidWhen: 'You can apply later, but do not wait if you are eligible',
    now: {
      best: 'The government window is typically open. Apply if you are a UK resident.',
      late: 'You can still apply. Do it now if you are eligible.',
      open: 'Most international students are not eligible. Apply in March if you are a UK resident.',
    },
  },
  bpifrance: {
    audiences: ['france', 'eu'],
    who: 'French or EU passport, often with 2 years of residence. Partner banks: SG, BNP, Caisse d’Épargne.',
    applyWhen: 'September to December — that is when bank envelopes open',
    avoidWhen: 'January to March — branches often say the guarantee envelope is gone',
    now: {
      best: 'Ask two partner banks now. There is no central portal.',
      late: 'Envelopes are often already gone. Ask anyway; some branches keep a little.',
      open: 'Most non-EU internationals are not eligible. If you are, wait for September.',
    },
  },
  smarto: {
    audiences: ['france', 'international'],
    who: 'Digital guarantor for CGE schools, then a French bank loan. Useful if you have no French guarantor.',
    applyWhen: 'Book the bank appointment before June for a September start',
    avoidWhen: 'July–August appointments often slip past the deposit date',
    now: {
      best: 'The guarantee is rolling; the bank slot is the bottleneck. Book it now.',
      late: 'Summer appointments slip. Book this week if you still need a French bank loan.',
      open: 'You can start the guarantee anytime. Lock a bank meeting before June.',
    },
  },
  employer: {
    audiences: ['international', 'india', 'us', 'uk', 'france', 'eu'],
    who: 'Your current firm — sponsorship, a loan, or a bond. Not a seasonal fund.',
    applyWhen: 'Start 6–9 months before you resign (Q4 / Q1 budgets)',
    avoidWhen: 'Do not wait until you have resigned',
    now: {
      best: 'Budget season. Write the pitch and ask now.',
      late: 'Still ask. A late yes is better than assuming no.',
      open: 'Start the conversation 6–9 months before you leave.',
    },
  },
};

export function hasBorrowerIdentity(nationality, residence) {
  return Boolean(String(nationality || '').trim() && String(residence || '').trim());
}

export function borrowerAudiences(nationality, residence) {
  const keys = [nationality, residence].map(normalizeCountry).filter(Boolean);
  const tags = new Set(['international']);
  if (keys.some((key) => INDIA.has(key))) {
    tags.add('india');
  }
  if (keys.some((key) => UNITED_STATES.has(key))) {
    tags.add('us');
  }
  if (keys.some((key) => UNITED_KINGDOM.has(key))) {
    tags.add('uk');
  }
  if (keys.some((key) => FRANCE.has(key))) {
    tags.add('france');
    tags.add('eu');
  }
  if (keys.some((key) => EUROPEAN_UNION.has(key))) {
    tags.add('eu');
  }
  return [...tags];
}

export function matchLenders(playbookId, nationality, residence) {
  if (!hasBorrowerIdentity(nationality, residence)) {
    return [];
  }
  const audiences = borrowerAudiences(nationality, residence);
  return Object.values(LENDERS)
    .filter((lender) => lender.regions.includes(playbookId))
    .map((lender) => ({ ...lender, ...(LENDER_META[lender.id] || {}) }))
    .filter((lender) =>
      (lender.audiences || ['international']).some((tag) => audiences.includes(tag))
    );
}

export function describeLenderWindow(lender, now = new Date()) {
  const status = lenderWindow(lender, now);
  const monthName = now.toLocaleString('en-US', { month: 'long' });
  const headlines = {
    best: `Apply now — ${monthName} is in the best window`,
    late: `Late for this cycle — ${monthName} is usually tight`,
    open: `Open — ${monthName} is not the peak month`,
  };
  const meta = LENDER_META[lender.id] || {};
  return {
    status,
    headline: headlines[status],
    applyWhen: meta.applyWhen || lender.window_label,
    avoidWhen: meta.avoidWhen || lender.late_label || '',
    nowMeaning: (meta.now && meta.now[status]) || lender.note,
    who: meta.who || lender.amount_note,
  };
}

export function lenderWindow(lender, now = new Date()) {
  const month = now.getMonth() + 1;
  if ((lender.best_months || []).includes(month)) {
    return 'best';
  }
  if ((lender.late_months || []).includes(month)) {
    return 'late';
  }
  return 'open';
}

export function lenderWindowLabel(lender, now = new Date()) {
  const status = lenderWindow(lender, now);
  if (status === 'best') {
    return 'Best window';
  }
  if (status === 'late') {
    return 'Often gone / late';
  }
  return 'Open';
}

function sourceApplies(source, targetId) {
  if (!source) {
    return false;
  }
  if (source.status === 'lost') {
    return false;
  }
  if (!source.target_id || !targetId) {
    return true;
  }
  return Number(source.target_id) === Number(targetId);
}

function sourceAmounts(source) {
  const announced = Number(source.announced_amount || 0);
  const likely = Number(source.evaluation?.amount_likely || announced || 0);
  const expected = Number(source.evaluation?.expected_value || 0);
  if (CERTAIN.has(source.status)) {
    return { certain: announced || likely, expected: 0 };
  }
  return { certain: 0, expected };
}

export function sliceTarget(slice, schoolCost) {
  if (slice.target === 'remainder') {
    return Math.max(0, Number(schoolCost || 0) - 30000 - 55000);
  }
  return Number(slice.target || 0);
}

export function sliceCoverage(slice, { profile, sources, targetId, schoolCost }) {
  const target = sliceTarget(slice, schoolCost);
  let certain = 0;
  let expected = 0;

  if (slice.kinds.includes('savings')) {
    certain += Number(profile?.savings_amount || 0);
  }
  if (slice.kinds.includes('family')) {
    certain += Number(profile?.family_contribution || 0);
  }
  if (slice.kinds.includes('employer')) {
    certain += Number(profile?.employer_sponsorship || 0);
  }

  (sources || []).forEach((source) => {
    if (!slice.kinds.includes(source.kind) || !sourceApplies(source, targetId)) {
      return;
    }
    const amounts = sourceAmounts(source);
    certain += amounts.certain;
    expected += amounts.expected;
  });

  const covered = certain + expected;
  let status = 'missing';
  if (target <= 0) {
    status = 'on_track';
  } else if (certain >= target) {
    status = 'on_track';
  } else if (covered >= target * 0.7) {
    status = 'short';
  } else if (covered > 0) {
    status = 'short';
  }

  return {
    target,
    certain,
    expected,
    covered,
    short: Math.max(0, target - covered),
    status,
  };
}

export function playbookSlack(playbook, schoolCost) {
  if (!playbook?.recipeTotal || !schoolCost) {
    return null;
  }
  const delta = playbook.recipeTotal - Number(schoolCost);
  if (Math.abs(delta) < 1000) {
    return null;
  }
  return {
    recipeTotal: playbook.recipeTotal,
    schoolCost: Number(schoolCost),
    delta,
  };
}

export function defaultSourceForSlice(slice, playbook, targetId, schoolCost) {
  const primaryKind = slice.kinds[0];
  const isScholarship = slice.id === 'scholarship' || primaryKind === 'scholarship';
  return {
    kind: primaryKind,
    origin: isScholarship ? 'school' : 'web',
    status: 'researching',
    name: slice.defaultName || slice.label,
    url: '',
    announced_amount: isScholarship ? '' : String(sliceTarget(slice, schoolCost) || ''),
    deadline: '',
    target_id: targetId ? String(targetId) : '',
    criteria_notes: slice.note || '',
  };
}

export function defaultSourceForLender(lender, playbook, targetId, loanTarget) {
  return {
    kind: lender.kind === 'research' ? 'loan' : lender.kind,
    origin: 'web',
    status: 'researching',
    name: lender.name,
    url: lender.url || '',
    announced_amount: lender.kind === 'loan' ? String(loanTarget || '') : '',
    deadline: '',
    target_id: targetId ? String(targetId) : '',
    criteria_notes: [lender.amount_note, lender.note].filter(Boolean).join(' '),
  };
}
